export default class Acc {
    constructor() {
        this.$accs = [...document.querySelectorAll('.js-acc')];
    }

    setHeight() {
        for (const $acc of this.$accs) {
            const $cont = $acc.querySelector('.js-acc_cont');

            $cont.removeAttribute('style');

            this._changeHeight($acc, $cont);
        }
    }

    eventBind() {
        for (const $acc of this.$accs) {
            const $toggle = $acc.querySelector('.js-acc_toggle');
            const $cont = $acc.querySelector('.js-acc_cont');

            $toggle.addEventListener('click', () => {
                $acc.classList.toggle('-active');
                this._changeHeight($acc, $cont);
            });
        }
    }

    _changeHeight($acc, $cont) {
        $cont.style.height = $acc.classList.contains('-active') ? `${$cont.scrollHeight}px` : 0;
    }

    initHeight() {
        clearTimeout(this.timer);

        this.timer = setTimeout(() => this.setHeight(), 300);
    }
}
